import db from '../../../db.json'

export const fetchData = () => {
  return db
}
